import moment from "moment-timezone";
moment.tz.setDefault("Europe/Warsaw");

const getUserStatChartData = (chart_data, range) => {
  if (!Object.keys(chart_data).length) {
    return [[0, 0]];
  }
  if (["yesterday", "today"].includes(range)) {
    return Object.keys(chart_data).map((key) => [
      moment.unix(key / 1000).format(`YYYY/MM/DD HH:mm`),
      chart_data[key] || 0,
    ]);
  }

  return Object.keys(chart_data).map((key) => [
    moment.unix(key / 1000).format(`YYYY/MM/DD`),
    chart_data[key] || 0,
  ]);
};

export default getUserStatChartData;
